import { Facebook, Linkedin, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { BRAND, WHATSAPP, SOCIALS, NAV } from "@/lib/site";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const SOCIAL_LINKS = [
  { icon: Facebook, href: SOCIALS.facebook, label: "Facebook", key: "facebook" },
  { icon: Linkedin, href: SOCIALS.linkedin, label: "LinkedIn", key: "linkedin" },
  { icon: Instagram, href: SOCIALS.instagram, label: "Instagram", key: "instagram" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-zi-ink pt-24 pb-10 text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="rounded-xl bg-white p-1.5">
                <img src={BRAND.logo} alt="Zippy Infosolution" className="h-10 w-10 object-contain" />
              </span>
              <span className="font-heading text-xl font-bold text-white">Zippy Infosolution</span>
            </div>
            <p className="mt-5 max-w-sm font-sans text-base leading-relaxed text-white/70">
              Quality BPO solutions for businesses. Reducing costs makes sense —
              we help you grow revenue with dependable calling, lead generation
              and admin support.
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${BRAND.email}`}
              className="mt-5 inline-flex items-center gap-2 font-heading font-semibold text-white transition-colors hover:text-zi-sky"
            >
              <Mail size={18} /> {BRAND.email}
            </a>
            <a
              data-testid="footer-phone-link"
              href="tel:+918822539911"
              className="mt-3 flex items-center gap-2 font-heading font-semibold text-white transition-colors hover:text-zi-sky"
            >
              <Phone size={16} className="text-zi-sky" /> +91 88225 39911
            </a>
            <div className="mt-3 inline-flex items-center gap-2 font-sans text-sm text-white/70">
              <MapPin size={16} className="text-zi-sky" /> {BRAND.address}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-white/50">Quick links</h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((item) => (
                <li key={item.href}>
                  <button
                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                    onClick={() => scrollTo(item.href)}
                    className="font-sans text-base text-white/70 transition-colors hover:text-white"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-white/50">Connect</h4>
            <div className="mt-5 flex gap-3">
              {SOCIAL_LINKS.map(({ icon: Icon, href, label, key }) => (
                <a
                  key={key}
                  data-testid={`footer-social-${key}`}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/15 bg-white/5 text-white transition-all duration-300 hover:border-zi-sky/60 hover:bg-zi-primary"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
            <a
              data-testid="footer-whatsapp-link"
              href={WHATSAPP.link}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2.5 font-sans text-sm text-white transition-colors hover:border-[#25D366]/60"
            >
              <span className="h-2 w-2 rounded-full bg-[#25D366]" /> WhatsApp {WHATSAPP.display}
            </a>
          </div>
        </div>

        <div className="mt-20 select-none">
          <div className="font-heading text-[13vw] font-black leading-none tracking-tighter text-white/[0.06] md:text-[9vw]">
            Zippy Infosolution
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-8 sm:flex-row">
          <p className="font-sans text-sm text-white/60">
            © {new Date().getFullYear()} Zippy Infosolution. All rights reserved.
          </p>
          <p className="font-sans text-sm text-white/60">Reducing costs makes sense</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
